module.exports = __webpack_public_path__ + "img/2.effe75f5.png";